import { RuntimeLessonScreen } from '@/features/unified-learning/runtime/screens/RuntimeLessonScreen';

export default function LearnPathLessonRoute() {
  return <RuntimeLessonScreen runtimeBase="/learn/path" />;
}
